
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "width": "17px",
    "height": "17px",
    "viewBox": "0 0 17 17",
    "enable-background": "new 0 0 17 17",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "id": "商品",
        "transform": "translate(-989 -664)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "商品-2",
            "fill": "#FFFFFF",
            "d": "M1003.805,667.769l-5.277-2.535c-0.65-0.311-1.406-0.311-2.056,0l-5.277,2.561\n\t\tc-0.72,0.313-1.188,1.021-1.194,1.806v5.772c0.018,0.789,0.48,1.501,1.195,1.837l5.305,2.558c0.32,0.156,0.671,0.236,1.027,0.232\n\t\tc0.355,0,0.707-0.079,1.028-0.232l5.25-2.535c0.721-0.325,1.188-1.04,1.195-1.832v-5.799\n\t\tC1004.988,668.811,1004.523,668.099,1003.805,667.769z M997,666.139c0.155-0.079,0.326-0.124,0.5-0.13\n\t\tc0.172-0.007,0.344,0.027,0.5,0.1l5.277,2.535c0.08,0.034,0.154,0.077,0.223,0.13l-6,2.894l-6-2.846\n\t\tc0.064-0.059,0.14-0.103,0.222-0.13L997,666.139z M991.722,676.275c-0.369-0.162-0.608-0.527-0.611-0.931v-5.555l2.222,1.061v2.329\n\t\tc-0.006,0.203,0.116,0.39,0.305,0.465l0.389,0.182c0.032,0.02,0.07,0.029,0.107,0.025c0.074,0.004,0.146-0.021,0.2-0.07\n\t\tc0.052-0.048,0.08-0.117,0.076-0.188v-2.226l2.5,1.19v6.234L991.722,676.275z M1003.277,676.275l-5.223,2.535v-6.256l5.834-2.764\n\t\tv5.558C1003.885,675.75,1003.646,676.113,1003.277,676.275L1003.277,676.275z"
          }
        }
      ]
    }
  ]
})
    }
  